import type { VariantProps } from "class-variance-authority"
import * as React from "react"
import { cva } from "class-variance-authority"

import { SearchIcon } from "@/domains/icons"
import { cn } from "@/domains/library"

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>

const searchVariants = cva(
  cn(
    "peer w-full items-center gap-2 rounded-lg",
    "text-t100",
    "border border-p400 hover:border-p200-shade focus-visible:border-p200-shade",
    "placeholder-t300-light placeholder-opacity-100",
    "transition-colors duration-300 ease-in-out",
    "outline-none focus-visible:outline-none",
    "disabled:cursor-not-allowed",
    "disabled:opacity-50",
    "focus-visible:ring-0",
  ),
  {
    variants: {
      variant: {
        default: "bg-p500 py-2.5 pl-9 pr-3",
        dialog: "mr-1 rounded-xl bg-p300 py-2 pl-[34px] pr-3",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
)

const Search = React.forwardRef<HTMLInputElement, InputProps & VariantProps<typeof searchVariants>>(
  ({ className, variant, type, value, ...props }, ref) => {
    return (
      <div className="relative flex w-full items-center text-sm text-t300">
        <SearchIcon
          size={16}
          className={cn(
            "pointer-events-none absolute flex h-4 w-4 items-center",
            "transition-colors duration-300 ease-in-out",
            "left-[12px]",
            Boolean(value) ? "text-t200" : "text-t300-light",
          )}
        />
        <input
          type={type}
          className={cn(searchVariants({ variant: variant }), className)}
          ref={ref}
          value={value}
          {...props}
          data-1p-ignore="true"
        />
      </div>
    )
  },
)
Search.displayName = "Input"

export { Search }
